import { paths } from "helpers/paths";
import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import * as source from "sources/books/documentTemplates";
import connect from "./container";
import Form from "./form";
import List from "./list";

function DocumentTemplates(props) {
    useEffect(() => {
        return () => props.clearParams("document-templates");
    }, []);

    const { location, history } = props;
    const back = () => history.push(paths.documentTemplates);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route
                    exact
                    path={paths.documentTemplatesNew}
                    render={() => (
                        <Form {...props} transition="full" title="Добавить шаблон" back={back} source={source} />
                    )}
                />
                <Route
                    path={paths.documentTemplatesShow(":id")}
                    render={(rest) => (
                        <Form {...rest} transition="full" title="Шаблон документа" back={back} source={source} />
                    )}
                />
                <Route
                    exact
                    path={paths.documentTemplates}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Шаблоны документов"
                            nofilter
                            createBtnText="Добавить шаблон"
                            back={() => history.push(paths.root)}
                        />
                    )}
                />
            </Switch>
        </div>
    );
}

export default connect(DocumentTemplates);
